import { render, staticRenderFns } from "./LeftSidebar.html?vue&type=template&id=66639c50&scoped=true&"
import script from "./LeftSidebar.js?vue&type=script&lang=js&"
export * from "./LeftSidebar.js?vue&type=script&lang=js&"
import style0 from "./LeftSidebar.scss?vue&type=style&index=0&id=66639c50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66639c50",
  null
  
)

export default component.exports